import { MutationTree } from "vuex";
import { FrState } from "./types";

export const mutations: MutationTree<FrState> = {};
